import { Chip, Stack, Typography } from "@mui/material";
import React, { FC, useState } from "react";
import CONSTANTS from "../../../../utils/constants";
import { useStyles } from "./styles";
import { Box } from "@material-ui/core";

interface QuickChipFilterProps {
  selectedChips;
  setSelectChips;
  issueCounts: Map<string, number>;
}

export const QuickChipFilter: FC<QuickChipFilterProps> = ({ selectedChips, setSelectChips, issueCounts }) => {
  const styles = useStyles();
  // Data for filter chips to enable mapping
  const filterChips = [
    {
      label: CONSTANTS.WATCHLIST.ISSUES.CONNECTION_ISSUES,
      count: issueCounts.get(CONSTANTS.WATCHLIST.ISSUES.CONNECTION_ISSUES),
    },
    {
      label: CONSTANTS.WATCHLIST.ISSUES.MISSING_WORKBOOK,
      count: issueCounts.get(CONSTANTS.WATCHLIST.ISSUES.MISSING_WORKBOOK),
    },
    {
      label: CONSTANTS.WATCHLIST.ISSUES.UNBUCKETED_ACCOUNTS,
      count: issueCounts.get(CONSTANTS.WATCHLIST.ISSUES.UNBUCKETED_ACCOUNTS),
    },
    { label: CONSTANTS.WATCHLIST.ISSUES.BOOKS_CLOSURE, count: issueCounts.get(CONSTANTS.WATCHLIST.ISSUES.BOOKS_CLOSURE) },
  ];

  // Handle chip toggle
  const handleToggle = (label) => {
    setSelectChips((prev) => {
      const existingChip = prev.find((chip) => chip.label === label);
      if (existingChip) {
        return prev.filter((chip) => chip.label !== label);
      } else {
        return [...prev, { label, status: true }];
      }
    });
  };

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Typography variant="button" color="text.secondary" className={styles.typography}>
        QUICK FILTERS: 
      </Typography> 

      {filterChips.map((chip, index) => {
        const isSelected = selectedChips.some((selectedChip) => selectedChip.label === chip.label);
        return (
          <Chip
            key={index}
            label={
              <Typography variant="body2" className={`${styles.chipLabel}`}>
                <span>{chip.label} </span>
                <span className={styles.chipCount}>({chip.count})</span>
              </Typography>
            }
            variant={isSelected ? "filled" : "outlined"}
            className={`${isSelected ? styles.chipFilled : styles.chipOutlined} ${styles.chip}`}
            clickable
            onClick={() => handleToggle(chip.label)}
          />
        );
      })}
    </Stack>
  );
};
